import React from 'react';
import './Banner.css';
import bannerBg from '../../assets/images/inner-banner.jpg';

const Banner = ({ title }) => {
  return (
    <section id="inner-banner" className="page_banner" style={{ backgroundImage: `url(${bannerBg})` }}>
      <div className="container">
        <div className="col-lg-12 col-md-12 col-xs-12">
          <div className="inner-heading">
            <h2>{title}</h2>
            <div className="separator">
              <ul>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;